const generator = require('./retailDeleted-fullcont-multitable-generator')

export const retailDeletedMT = [
      {
            tableName: 'sale_vs_item',
            value: '',
            id: 'retailDeleted_form_sale_vs_item',
            html: '',
            data: [],
            dataCopy: [],
            oneRequired: false,
            fields: [
                  { name: 'purchase_vs_itemId', type: 'autocomplete', html: '', required: false },
                  { name: 'selling_type', type: 'textfield', html: '', required: false },
                  { name: 'qty', type: 'textfield', html: '', required: false },
                  { name: 'cost', type: 'textfield', html: '', required: false },
                  { name: 'cogs_row_amount', type: 'textfield', html: '', required: false },
                  { name: 'price', type: 'textfield', html: '', required: false },
                  { name: 'total', type: 'textfield', html: '', required: false },
            ],
            generator: function (line) {
                  return generator.saleVsItem(line.id, line.purchase_vs_itemId)
            },
            add: function () {
                  return false
            },
      },
]
